import React from "react";
import { Routes, Route } from "react-router-dom";
import ListBuilders from "../Components/Builder Approval/listBuilders";
import AddBuilder from "../Components/Builder Approval/addBuilder";
import ViewBuilder from "../Components/Builder Approval/viewBuilder";
import ReviewBuilder from "../Components/Builder Approval/reviewBuilder";

const BuilderRoutes = () => {
  return (
    <Routes>
      <Route
        path="/builders"
        element={<ListBuilders></ListBuilders>}
      ></Route>
      <Route path="/builders/add" element={<AddBuilder></AddBuilder>}></Route>
      <Route path="/builders/view/:id" element={<ViewBuilder> </ViewBuilder>}></Route>
      <Route path="/builders/:id/review" element={<ReviewBuilder></ReviewBuilder>}></Route>
    </Routes>
  );
};

export default BuilderRoutes;
